import React from 'react';
import { Link } from 'react-router-dom';
import BlueCallToAction from '../components/common/BlueCallToAction';

const HomePage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="py-20" style={{
        background: `linear-gradient(to top, #FFC000 0%, #FFFFFF 3%, #FFFFFF 97%, #FFC000 100%)`
      }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900">
              <span style={{ color: '#FFC000' }}>Actionable</span> Healthcare Insights
              <br />
              with AI Automation
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 text-gray-700">
              We've solved the challenge of healthcare claim denials and
              revenue cycle optimization. Our AI-powered platform
              provides clarity for effective decision making and financial
              goal achievement in healthcare operations.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact"
                style={{ 
                  backgroundColor: '#0E3056',
                  color: 'white',
                  padding: '1rem 2rem',
                  borderRadius: '0.5rem',
                  fontWeight: '600',
                  transition: 'background-color 0.2s'
                }}
                className="hover:bg-opacity-90"
              >
                Request Demo
              </Link>
              <Link
                to="/plans"
                style={{ 
                  border: '2px solid #0E3056',
                  color: '#0E3056',
                  padding: '1rem 2rem',
                  borderRadius: '0.5rem',
                  fontWeight: '600',
                  transition: 'all 0.2s'
                }}
                className="hover:bg-[#0E3056] hover:text-white"
              >
                View Our Plans
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center text-gray-900 dark:text-white">
            Decision Making, Efficiency & Outcomes
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* Revenue Cycle Intelligence */}
            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <img src="/assets/icons/revenue-analytics.svg" alt="Revenue Analytics" className="w-12 h-12" />
                <Link 
                  to="/features/revenue-cycle"
                  style={{ color: '#FFC000' }}
                  className="hover:opacity-80 font-medium"
                >
                  Learn more →
                </Link>
              </div>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                Revenue Cycle Intelligence
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Identify causes of increases in DNFB and DNSP metrics.
              </p>
            </div>

            {/* Claims Denial Prevention */}
            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <img src="/assets/icons/ai-shield.svg" alt="AI Shield" className="w-12 h-12" />
                <Link 
                  to="/features/claims-denial"
                  style={{ color: '#FFC000' }}
                  className="hover:opacity-80 font-medium"
                >
                  Learn more →
                </Link>
              </div>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                Claims Denial Prevention & Management
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Advanced AI-driven system to prevent claim denials before they occur and
                streamline appeals processes. Reduce administrative burden while improving
                claim acceptance rates and revenue cycle efficiency.
              </p>
            </div>

            {/* Secure Data Integration */}
            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <img src="/assets/icons/secure-health-data.svg" alt="Secure Health Data" className="w-12 h-12" />
                <Link 
                  to="/features/secure-integration"
                  style={{ color: '#FFC000' }}
                  className="hover:opacity-80 font-medium"
                >
                  Learn more →
                </Link>
              </div>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">
                Secure Data Integration
              </h3>
              <p className="text-gray-600 dark:text-gray-300">
                Protect sensitive health data to support privacy and security while
                managing evolving compliance requirements. Close the loop and
                enable data to flow in real-time through every point of care.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <BlueCallToAction 
        heading="Ready to transform your healthcare operations?"
        description="Experience how our AI-powered platform can drive efficiency and optimize your revenue cycle."
        primaryButtonText="Request Demo"
        primaryButtonLink="/contact"
        secondaryButtonText="Contact Us"
        secondaryButtonLink="/contact"
      />
    </div>
  );
};

export default HomePage; 
